import { render, staticRenderFns } from "./BirthCertificateCommitmentPrint.vue?vue&type=template&id=db218be6&scoped=true"
import script from "./BirthCertificateCommitmentPrint.vue?vue&type=script&lang=js"
export * from "./BirthCertificateCommitmentPrint.vue?vue&type=script&lang=js"
import style0 from "./BirthCertificateCommitmentPrint.vue?vue&type=style&index=0&id=db218be6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db218be6",
  null
  
)

export default component.exports